import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {frames, glyphs, images } from '../../../Styles'
import { ButtonList, AutoReportWidget, PageHeader, NewInput, NewCreatableSelect, ArchivedReportCard, NewSelect } from '../../../Components'
import { Pages } from '../../../Navigation/Routers/root'
import { ArchivedReportData } from '../../../Assets/TestData/reports'
import CardsView from '../../../Assets/TestData/cardsView'
import Last10DaysViewer from '../../../Components/curveViewer/animalGraph'
import { useAnimal } from '../../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/useAnimal'
import { useAppSelector } from '../../../Store'
import { Graph_QL } from '../../../Services'
import { Consumption } from '../../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/GQLCalls/getAnimalCall'

export default function Kpi() {
  const { t } = useTranslation()
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const domain = useMemo(() => Graph_QL.ObjToString({ domain: farm }), [farm]);
  const connection = useMemo(() => Graph_QL.create({ domain: farm }), [farm]);

  const { call: getAnimals, data: animalsState } = useAnimal(connection);

  useEffect(() => {
    getAnimals({}, connection);
    // eslint-disable-next-line
  }, []);

  // const animalConsumption = useMemo(() => animalsState[domain]?.data.map(animal => animal.lastTenDay) as Consumption[], [animalsState, domain])

  return (
    <frames.Page_inner>
      <frames._page_inner_header>
        <div style={{display: "flex", flexDirection: "row", alignItems: "start", justifyContent: "space-between"}}>
        <PageHeader topHeader={t(`menuHeaders.${Pages.kpi}`, {defaultValue: "kpi"})} subHeader={t("menuHeaders.overview", {defaultValue: "overview"})}/>
          <ButtonList 
            contents={["edit kpi dashboard"]} 
          />
        </div>
      </frames._page_inner_header>
      <frames._page_inner_content_scroll>
        {/* {!animalConsumption || animalConsumption.length === 0
          ? <></>
          : < Last10DaysViewer data={animalConsumption}/>
        } */}
        <NewSelect options={[]} isClearable isSearchable/>
        <NewCreatableSelect options={[]} isClearable isSearchable/>
      </frames._page_inner_content_scroll>
      </frames.Page_inner>
  );
}